import axios from "axios";

export function updateAccounts(data, accountId, type) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/accounts`,
    data: data
  };
  return axios(config);
}

export function updateBusiness(data, accountId, type) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/business`,
    data: data
  };
  return axios(config);
}

export function updateBusinessInfo(data, accountId, type) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/business-info`,
    data: data
  };
  return axios(config);
}

export function updateOrderLimits(accountId, data, id, type) {
  console.log("accountId: ", accountId)
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/order-limits/${id}`,
    data: data
  };
  return axios(config);
}

export function updateAccountSSo(data, accountId, type) {
  console.log("accountId: ", accountId)
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/account-sso`,
    data: data
  };
  return axios(config);
}

export function updateLargeOrder(data, accountId, type) {
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/large-order`,
    data: data
  };
  return axios(config);
}

export function updatePrinter(accountId, shop, data, type) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/printers/${data.printer.did}`,
    params: shop,
    data
  }
  return axios(config);
}

export function updateInvoiceTitle(accountId, data, type) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/invoice`,
    data
  }
  return axios(config);
}

export function updateInvoicePrinterParams(accountId, data, type) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/invoice-printer`,
    data
  }
  return axios(config);
}

export function updatePosmw(accountId, id, data, type) {
  let config = {
    method: 'PUT',
    url: `${process.env.VUE_APP_APIHOST}/${type}/console/${accountId}/mw-settings/${id}`,
    data
  };
  return axios(config);
}


export function updateSubscriber(accountId, type, subscribeType, data) {
  let config = {
    method: "post",
    url: `${process.env.VUE_APP_APIHOST}/${type}/air3/${accountId}/types/${subscribeType}/subscribe`,
    data: data
  };
  return axios(config);
}
